import React from 'react';
import { useTranslation } from 'react-i18next';
import './AdminSidebar.css';

const AdminSidebar = ({ activeTab, setActiveTab, handleLogout }) => {
  const { t } = useTranslation();

  const menuItems = [
    { id: 'ebs', label: t('adminSidebar.ebs') },
    { id: 'akademisyen-toplu', label: t('adminSidebar.bulkAdd') },
    { id: 'auto-assign-courses', label: t('adminSidebar.autoAssign') },
    { id: 'feedback', label: t('adminSidebar.viewRequests') },
    { id: 'reset', label: t('adminSidebar.passwordReset') },
    { id: 'role-assignment', label: t('adminSidebar.roleAssign') },
    { id: 'active-users', label: t('adminSidebar.activeUsers') },
    { id: 'term-outcomes', label: 'Dönem Sonuçları' },
    { id: 'academic-year', label: 'Yeni Akademik Yıl' }
  ];

  return (
    <aside className="admin-sidebar">
      <div className="admin-menu-container">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`admin-menu-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <button className="admin-logout-btn" onClick={handleLogout}>
        {t('adminSidebar.logout')}
      </button>
    </aside>
  );
};

export default AdminSidebar;
